export default __webpack_public_path__ + "static/media/307.0a64874b.jpg";